import { SpeiAttemptsByNode } from '@app/domain/models/spei/spei-attempts-by-node';
import { SpeiIndividualAttemptKeys } from '@app/domain/models/spei/spei-order-attempt-memory';

/**
 * Memoria de intentos por origen de las órdenes SPEI de Suite (feature 125).
 *
 * ⚠️ Se enlaza UNA vez en la raíz (`app.config.ts`, `useExisting` al singleton de
 * la pestaña). Proveerla en una página la re-crearía con cada montaje y volvería a
 * estrenar llave al salir y volver (el doble SPEI que esta feature cierra).
 */
export abstract class SpeiOrderAttemptMemory {
  abstract readonly orders: SpeiAttemptsByNode<SpeiIndividualAttemptKeys>;
  /** La `idempotency_key` del lote: las claves de rastreo no entran en la huella. */
  abstract readonly batches: SpeiAttemptsByNode<string>;
  /** Cierre de sesión / inicio de login: borra los intentos de los dos tipos. */
  abstract clear(): void;
}
